// Module
var code = `<table class="table table--wide table--tiny-inputs"
       at-table
       at-list="\$ctrl.getVariables()">
  <thead></thead>
  <tbody>
  <tr>
    <td
      class="print-details__control-number"
      at-title="No">
      {{\$index+1}}.
    </td>
    <td at-implicit at-attribute="field" at-title="Variable code"></td>
    <td at-title="Status">
      <select
        required
        class="print-details__control-input"
        ng-model="item.active"
        ng-change="\$ctrl.onChange()"
        boolean-options>
      </select>
    </td>
    <td at-title="X">
      <glue-container append="'mm'">
        <input class="print-details__control-input"
               type="number"
               ng-model="item.x"
               ng-change="\$ctrl.onChange()"
               min="0"/>
      </glue-container>
    </td>
    <td at-title="Y">
      <glue-container append="'mm'">
        <input
          class="print-details__control-input"
          type="number"
          ng-model="item.y"
          ng-change="\$ctrl.onChange()"
          size="5"
          min="0"/>
      </glue-container>
    </td>
    <td at-title="Max length (0 to disable)">
      <glue-container append="'mm'">
        <input
          class="print-details__control-input"
          type="number"
          ng-model="item.maxLength"
          ng-change="\$ctrl.onChange()"
          size="5"
          min="0"/>
      </glue-container>
    </td>
    <td at-title="Padding character">
      <input
        class="print-details__control-input"
        type="text"
        ng-model="item.paddingCharacter"
        ng-change="\$ctrl.onChange()"
        maxlength="1"
        size="5"
        min="0"/>
    </td>
    <td at-title="Field length (0 to disable)">
      <glue-container append="'characters'">
        <input
          class="print-details__control-input"
          type="number"
          ng-model="item.fieldLengthIncludingPadding"
          ng-change="\$ctrl.onChange()"
          ng-required="item.paddingCharacter != null && item.paddingCharacter.length > 0"
          data-toggle="tooltip"
          title="Required when padding character is set"
          size="5"
          min="0"/>
      </glue-container>
    </td>
    <td at-title="Font size">
      <input
        class="print-details__control-input"
        type="number"
        ng-model="item.fontSize"
        ng-change="\$ctrl.onChange()"
        size="5"
        min="1"/>
    </td>
    <td at-title="Sample text:">
              <textarea
                ng-model="item.text"
                ng-change="\$ctrl.onChange()"
                cols="20"
              ></textarea>
    </td>
    <td at-title="Action:">
      <button type="button"
              class="btn btn-success"
              ng-if="\$ctrl.isPrimary(item)"
              ng-click="\$ctrl.addVariable(item) && \$ctrl.onChange()">
        Add
      </button>
      <button type="button"
              class="btn btn-danger"
              ng-if="!\$ctrl.isPrimary(item)"
              ng-click="\$ctrl.removeLine(item) && \$ctrl.onChange()">
        Remove
      </button>
    </td>
  </tr>
  </tbody>
</table>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/prints/prints-details-variable-configuration.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;